import {copyToClipboard} from '@logistics-frontend/utils'
import {useState} from 'react'

const useCopyOnClick = (timeout = 3000) => {
  const [copied, setCopied] = useState(false)
  return {
    copied,
    onCopyClick: (value?: string | null) => {
      setCopied(true)
      setTimeout(() => setCopied(false), timeout)
      if (value) {
        try {
          copyToClipboard(value)
        } catch (e) {}
      }
    },
  }
}

export default useCopyOnClick
